<template>
  <div class="verify-page">
    <div class="verify-page-top"  >
      <div>您查询的商品为<span class="success-text">正品</span></div>
      <div>
        本防伪码当前第 <span class="times-text">{{props.search_count
        }}</span> 次被查询
      </div>
    </div>
    <div class="verify-page-bottom">
      <div>
        防伪码:&nbsp;&nbsp;{{inputValue}}
      </div>
      <div>
        首次查询时间:&nbsp;&nbsp;{{props.first_sacn_time}}
      </div>
    </div>
  </div>
</template>

<script lang="js" setup>
import { computed,ref,onMounted  } from 'vue'
import { useRoute } from 'vue-router'
import http from "@/api"
const route = useRoute()
const isLoading  = ref('')
const loading = ref('')
const inputValue = ref('')

function GetUrlParam(paraName) {
  const url = document.location.href;

  const directQuery = new URL(url).searchParams.get(paraName);
  if (directQuery) {
    return directQuery;
  }

  const hashIndex = url.indexOf("#");
  if (hashIndex > -1) {
    const hashPart = url.slice(hashIndex + 1);
    const hashQueryIndex = hashPart.indexOf("?");
    if (hashQueryIndex > -1) {
      const hashQuery = hashPart.slice(hashQueryIndex + 1);
      const valueFromHash = new URLSearchParams(hashQuery).get(paraName);
      if (valueFromHash) {
        return valueFromHash;
      }
    }
  }

  return "";
}
  const props = defineProps(['search_count','first_sacn_time'])
  // const search_count = ref('')
  // const first_sacn_time = ref('')
const search = () => {
  if (!inputValue.value) {
    ElMessageBox.confirm("请输入防伪码", "提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    isLoading.value = false
    return
  }
  loading.value = true
  http.get(`/qrcode_search/${inputValue.value}`).then((res) => {
    first_sacn_time.value = res.data.first_sacn_time;
    search_count.value =res.data.search_count
  }).finally(() => {
    isLoading.value = false
    loading.value = false
  })
}
onMounted(() => {
  // code.value = GetUrlParam("code") || ''
  // if(code.value == 'QYKJ'){
  //    document.title='微原防伪溯源系统'
  // }
  inputValue.value = GetUrlParam("qid") || ''
  // if( inputValue.value){
  //     search()
  //   }
  // if( inputValue.value){
  //   search()
  // }else if(GetUrlParam('code')){
  //   getDetail(GetUrlParam('code'))
  // }else{
  //   // template.value = 'template4'
  //   template.value = 'template_common1'
  //   // console.log(" isLoading.value", isLoading.value)
  //   isLoading.value = false
  //   // console.log(" isLoading.value", isLoading.value)
  // }
})
</script>

<style lang="scss" scoped>
.verify-page {
  min-height: 100vh;
  min-height: max(100vh, calc(100vw * 2416 / 1216));
  min-height: max(100dvh, calc(100vw * 2416 / 1216));
  background: #f3faf6;
  color: #1b1b1b;
  position: relative;
  background: #f3faf6 url('../assets/success.jpg') no-repeat top center;
  background-size: 100% auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Microsoft YaHei", sans-serif;
}

@media (max-aspect-ratio: 1216/2416) {
  .verify-page {
    background-size: 100% 100%;
  }
}
.verify-page-top{
  font-size: 12px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  >div:nth-child(1){
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4px;
    color: black;
    letter-spacing: 1px;
  }
  >div:nth-child(2){
    font-size: 12px;
    color: #333;
  }
  .success-text{
    color: #009900;
  }
  .times-text{
    font-weight: 700;
    color: black;
    font-size: 14px;
  }
}
.verify-page-bottom{
  font-size: 12px;
    position: absolute;
    top: 49%;
    left: 10px;
    >div:nth-child(1){
      margin-bottom: 6px;
    }
}
</style>